module.exports = __webpack_public_path__ + "static/media/enable.cec0501c.png";